import { render, staticRenderFns } from "./authoriedStore.vue?vue&type=template&id=85dd65f6&scoped=true&"
import script from "./authoriedStore.vue?vue&type=script&lang=js&"
export * from "./authoriedStore.vue?vue&type=script&lang=js&"
import style0 from "./authoriedStore.vue?vue&type=style&index=0&id=85dd65f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dd65f6",
  null
  
)

export default component.exports